import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign "signal is aborted" and "user aborted" errors from WaveSurfer
// These occur when audio loading is cancelled during navigation
window.addEventListener('error', (event) => {
  const msg = event.message || '';
  if (msg.includes('aborted')) {
    event.preventDefault();
    event.stopPropagation();
    return true;
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message || String(event.reason || '');
  if (msg.includes('aborted')) {
    event.preventDefault();
    event.stopPropagation();
    return;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
